// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__27xBI","header":"ClearentDisclaimer_header__1ibiG","inner":"ClearentDisclaimer_inner__2ISXF"};